import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { BsForm, BsFormButton, BsFormControl, BsInputPassword, BsModal } from '../collection/bootstrap/BootstrapComponents';
import Center from '../collection/styles/Center';
import { apiForm, apiGet } from '../utils/api';
import { validateEmail } from '../utils/functions';
import { notify } from '../utils/notifications';
import './Login.scss';

export default function Login(props) {
    // recovery email
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState();
    const [loading, setLoading] = useState(false);

    const sendRecoveryEmail = async () => {
        setLoading(true);
        if (!email) {
            notify("Introduzca un correo electrónico", "warning");
        }
        else if (!validateEmail(email)) {
            notify("Introduzca una dirección válida", "warning");
        }
        else {
            if (await apiGet("usuarios/recoveryEmail/" + email)) {
                setShow(false);
                setEmail("");
                notify("Correo de recuperación enviado", "success");
            }
        }
        setLoading(false);
    }

    // login
    const updateData = () => {
        return { username: "", password: "" };
    };

    const saveData = async (data) => {
        const result = await apiForm("sesion/login", data);
        if (result) {
            props.onLogin(result);
        }
    }

    // render
    return <>
        <Center>
            <BsForm
                onUpdate={updateData}
                onSave={saveData}
                saveOnEnter>
                <LoginForm />
            </BsForm>
            <div className="mt-2 link" onClick={e => setShow(true)}>He olvidado mis datos</div>
        </Center>
        <BsModal
            modalTitle="Recuperar datos de acceso"
            saveBtnText="Enviar correo"
            show={show} onHide={e => setShow(false)}
            onSave={sendRecoveryEmail}
            isSaving={loading}
            saveOnEnter>
            <BsFormControl
                label="Correo electrónico"
                value={email} isControlled
                onChange={e => setEmail(e.target.value)} />
        </BsModal>
    </>;
}

function LoginForm(props) {
    return <Form.Group>
        <Form.Control placeholder="Usuario" name="username" />
        <BsInputPassword placeholder="Contraseña" name="password" className="mt-3" />
        <BsFormButton onClick={props.onSubmit} isLoading={props.isSaving} className="mt-3">
            Entrar
        </BsFormButton>
    </Form.Group>;
}
